import _ from 'lodash';
import {Module, Component} from '../decorators';

import tpl from './order.status.html';


@Module({
    name: "app.orders.compontents.order.status",
})
@Component({
    selector: 'blnd-order-status',
    template: tpl,
    bindings: {
        ngModel: '=',
        mode: '@',
        inputClass: '@',
    },
})
export default class C {
    constructor (Config, $element) {
        "ngInject";
        let self = this;
        self.$element = $element;
        self.statuses = Config.$config.order.statuses;
        self.statusMap = _.fromPairs(self.statuses);
    }

    getName () {
        let self = this;
        return self.statusMap[self.ngModel];
    }

    $onDestroy () {
        delete this.statuses;
        delete this.statusMap;
        this.$element.remove();
        this.$element = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/order.status.js